import { useEffect, useState } from "react";
import { MOBILE_VIEW, TABLET_VIEW } from "./consts";

export const useWindowSize = () => {
  const [windowSize, setWindowSize] = useState<number>(undefined);

  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (!windowSize) return undefined;

  const isMobile = windowSize < MOBILE_VIEW;
  const isTablet = windowSize < TABLET_VIEW;
  const isDesktop = windowSize >= TABLET_VIEW;

  return {
    isMobile,
    isTablet,
    isDesktop,
  };
};
